var data = {
	"body": "<path d=\"M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z\" fill=\"currentColor\"/>",
	"width": 384,
	"height": 512
};
exports.__esModule = true;
exports.default = data;
